import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography, SpacerVertical } from '@klarna/bubble-ui';
import { getMerchantAwareTranslator } from '@/selectors/merchant';

const style = {
  flex: {
    flex: '1 1 50%',
  },
};

const generateTitle = (t, title, titleKey) => {
  if (title) {
    return title;
  } else if (titleKey) {
    return t(titleKey);
  } else {
    return null;
  }
};

const SummaryField = ({ tMerchantAware, title, titleKey, content, ...rest }) => (
  <div style={style.flex} {...rest}>
    <Typography textToken="text-style/text/labels/tiny/regular" colorToken="colors/text/neutral">
      {generateTitle(tMerchantAware, title, titleKey)}
    </Typography>
    <SpacerVertical spaceToken="space/50" />
    <Typography textToken="text-style/text/super-paragraphs/body/regular">{content}</Typography>
    <SpacerVertical spaceToken="space/150" />
  </div>
);

SummaryField.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
  tMerchantAware: PropTypes.func.isRequired,
  title: PropTypes.string,
  titleKey: PropTypes.string,
};

export default connect(state => ({
  tMerchantAware: getMerchantAwareTranslator(state),
}))(SummaryField);
